import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowReloadHorizontalIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M16.6111 4.94482H8.05556C5.16745 4.94482 3 7.03318 3 10.0004'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M3.39062 15.0556H11.9462C14.8343 15.0556 17.0017 12.9672 17.0017 10'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.0586 3C15.0586 3 17.003 4.43206 17.003 4.94446C17.003 5.45686 15.0586 6.88889 15.0586 6.88889'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4.94443 13.1113C4.94443 13.1113 3.00001 14.5434 3 15.0558C2.99999 15.5682 4.94445 17.0002 4.94445 17.0002'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowReloadHorizontalIcon;
